import { connect } from 'react-redux'
import Menu from '../Components/Menu'
import { mapStateToPropsAddable } from '../Utils/mapToProps'

const mapStateToProps = (state, ownProps) => ({
    ...mapStateToPropsAddable(state, ownProps),
    gridElements: ['label','blank','picto', 'titre'],
    spanElements: ['texte'],
    min: 2,
    refs: id => ({
        label: {
            type: 'LabelAdd',
            label: 'picto-order'
        },
        blank: {
            type: 'Blank'
        },
        picto: {
            type: 'InputTextContainer',
            name: `${id}/picto`,
            label: 'picto'
        },
        titre: {
            type: 'InputTextContainer',
            name: `${id}/titre`,
            label: 'titre'
        },
        texte: {
            type: 'TextAreaContainer',
            name: `${id}/texte`,
            label: 'secteur'
        }
    })
})

export default connect(
    mapStateToProps
)(Menu)

